import React from 'react'
import styled from 'styled-components'
import EgrStaticBanner from '../images/egr_static_banner.jpg'

const ImageBox = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
`

const Image = styled.img`
    display: block;
    height: 9rem;
    width: 100%;
    object-fit: cover;
    @media (min-width: 480px) {
        height: 9rem;
    }
    @media (min-width: 500px) {
        height: 10rem;
    }
    @media (min-width: 700px) {
        height: 12rem;
    }
    @media (min-width: 800px) {
        height: 14rem;
    }
    @media (min-width: 960px) {
        height: 18rem;
    }
    @media (min-width: 1200px) {
        height: auto;
        width: 100%;
    }
    // @media (min-width: 1340px) {
    //     height: 22rem;
    // }
    // @media (min-width: 1480px) {
    //     height: 24rem;
    // }
`

function StaticHeaderBanner() {

    return (
        <ImageBox>
            <Image src={EgrStaticBanner} />
        </ImageBox>
    )
}

export default StaticHeaderBanner
